<div class="journeyItem" [ngClass]="statusClass()">
    <span class="statusDot" [ngClass]="status === 'complete'? 'material-icons': null"></span>
    <mat-icon>{{ icon }}</mat-icon>
    <p>
        <ng-content></ng-content>
    </p>
</div>
